import React, { Component } from 'react'
import moment from 'moment'
import $ from 'jquery'
import { AppSettings, MessageText, Storage } from '../../configs'

import {
    SecureGateRoute,
    BreadCrumb,
    UserManualModal,
    SearchEmployeeModal
} from "../../components"
import {
    getUserManualDataAction,
    updateUserManualModalAction,
    deleteUserManualAction,
    clearErrorMsgAction,
    getAllUserAction,

} from '../../redux/actions/UserManualAction'
import { connect } from 'react-redux'
import { Div, Input, DatePicker, Select, TextArea } from "../../components/core";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from "@material-ui/core/TablePagination";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { msg } from '../../components/Notifications/MsgBox';

import '../../assets/css/rrs.css'
import { getAllOrgUnitsAction } from '../../redux/actions/MasterAction'
import UserServices from '../../services/UserServices';



class ManualScreen extends Component {
    constructor(props) {
        super(props)

        this.state = {
            order_user: "asc",
            orderBy_user: "",
            page_user: 0,
            rowsPerPage_user: 10,
            filteruserDataArr: [],
            filter_username: '',
            filter_firstName: '',
            filter_lastName: '',
            filter_email: '',
            filter_unitCode: '',
            filter_isAdmin: '',
            filter_userGroup: '',
            filter_status: '',
            appReadonly: false
        }

        this.handleRequestSort = this.handleRequestSort.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.handleChangefilter = this.handleChangefilter.bind(this)
        this.setUserManualModal = this.setUserManualModal.bind(this)
        this.setDefaultPage = this.setDefaultPage.bind(this)
        this.loadDataManualUserAll = this.loadDataManualUserAll.bind(this)
        window.onSavePopupUser = this.loadDataManualUserAll.bind(this)
    }

    componentDidMount() {
        //this.props.getUserManualData()
        this.loadDataManualUserAll()
        this.handleApplicationCheckReadonly()

        $(function () {
            window.onComponentDidMount()
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.userManualData !== this.state.filteruserDataArr) {

            this.setState({
                filteruserDataArr: nextProps.userManualData
            })

        }
    }

    
    async handleApplicationCheckReadonly()
        {
            UserServices.ApplicationReadonly().then(response=>{
                if(response.data === true)
                {
                    this.setState({appReadonly: true})
                }
            })
        }
    

    async loadDataManualUserAll() {
        await this.props.getUserManualData()

        this.filterdata()
        const role = Storage.getRole()
        const roleAdmin = Storage.getRoleAdmin()
        console.log('role',role)
        console.log('roleAdmin',roleAdmin)
        console.log('this.props.userManualData',this.props.userManualData)
        let filteruserData = []
        filteruserData = this.props.userManualData
        console.log('filteruserData',filteruserData)
        if(!roleAdmin)
        filteruserData = filteruserData.filter((data) => {
            
                if(role == 'C'){
                    return data.user_group == "Creator" || data.user_group == "Committee" 
                }else{
                    return data.user_group == "Reviewer" || data.user_group == "Committee" 
                }
            
            
            
        })
        
        await this.setState({ filteruserDataArr: filteruserData })
        this.setDefaultPage()
    }

    setDefaultPage() {
        this.setState({
            page_user: 0
        })
    }

    setUserManualModal(index = "") {
        this.props.clearErrorMsg()
        this.props.updateUserModal(index)
        // console.log("setUserManualModal", data)
    }

    delUser(id,file_path) {
        msg.showConfirm(
            "Confirm",
            MessageText.PAGE.USERMANUAL.POPUP_MSG_CONFIRM_DELETE,
            () => {
                
                this.props.deleteUser(id,file_path).then(() => {
                    msg.hideConfirm()
                    msg.success(MessageText.PAGE.USERMANUAL.POPUP_MSG_SUCCESS_DELETE)
                    this.props.getUserManualData().then(() => {})
                }).catch(error => console.log("error : " + error));
                
            },
            () => {
                msg.hideConfirm()
                console.log("On Cancel")
            },
            () => {
                console.log("On Closed")
            }
        )
    }

    // Grid start

    desc(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    stableSort(array, cmp) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = cmp(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map(el => el[0]);
    }

    getSorting(order, orderBy) {
        return order === "desc"
            ? (a, b) => this.desc(a, b, orderBy)
            : (a, b) => -this.desc(a, b, orderBy);
    }

    handleRequestSort(event, property) {
        const isDesc = this.state.orderBy_user === property && this.state.order_user === "desc";
        this.setState({
            order_user: isDesc ? "asc" : "desc",
            orderBy_user: property
        })
    }

    handleChangePage(event, newPage) {
        this.setState({
            page_user: newPage
        })
    }

    handleChangeRowsPerPage(event) {
        this.setState({
            rowsPerPage_user: +event.target.value,
            page_user: 0
        })
    }

    // Grid end

    async handleChangefilter(event) {
        event.preventDefault()
        const { name, value } = event.target;

        await this.setState({ [name]: value })

        this.filterdata()
    }

    async filterdata() {
        
        let filteruserData = []
        filteruserData = this.props.userManualData

        const { filter_username, filter_firstName, filter_lastName, filter_email, filter_unitCode, filter_isAdmin, filter_userGroup, filter_status } = this.state

        if (filter_username) {
            filteruserData = filteruserData.filter((data) => {
                return data.userName && data.userName.toLowerCase().indexOf(filter_username.toLowerCase()) > -1
            })
        }
        if (filter_firstName) {
            filteruserData = filteruserData.filter((data) => {
                return data.firstName && data.firstName.toLowerCase().indexOf(filter_firstName.toLowerCase()) > -1
            })
        }
        if (filter_lastName) {
            filteruserData = filteruserData.filter((data) => {
                return data.lastName && data.lastName.toLowerCase().indexOf(filter_lastName.toLowerCase()) > -1
            })
        }
        if (filter_email) {
            filteruserData = filteruserData.filter((data) => {
                return data.email && data.email.toLowerCase().indexOf(filter_email) > -1
            })
        }
        if (filter_unitCode) {
            filteruserData = filteruserData.filter((data) => {
                return data.unitCode && (data.unitCode.indexOf(filter_unitCode) > -1 || data.unitSubName.indexOf(filter_unitCode) > -1)
                //return data.unitCode && data.unitCode.indexOf(filter_unitCode) > -1
            })
        }
        if (filter_userGroup) {
            if (filter_userGroup == 1) {
                filteruserData = filteruserData.filter((data) => {
                    return data.user_group == "Creator"
                })
            }
            if (filter_userGroup == 2) {
                filteruserData = filteruserData.filter((data) => {
                    return data.user_group == "Reviewer"
                })
            }
        }
        if (filter_isAdmin) {
            if (filter_isAdmin == 1) {
                filteruserData = filteruserData.filter((data) => {
                    return data.isAdmin == true
                })
            }
            if (filter_isAdmin == 2) {
                filteruserData = filteruserData.filter((data) => {
                    return data.isAdmin == false
                })
            }
        }
        if (filter_status) {
            if (filter_status == 1) {
                filteruserData = filteruserData.filter((data) => {
                    return data.isActive == true
                })
            }
            if (filter_status == 2) {
                filteruserData = filteruserData.filter((data) => {
                    return data.isActive == false
                })
            }
        }

        await this.setState({ filteruserDataArr: filteruserData })
        this.setDefaultPage()
    }

    onUploadComplete = () => {
        window.$('#userManualModal').modal('hide');
    }

    render() {
        const { userManualData, org_unit } = this.props
        const { filteruserDataArr, appReadonly } = this.state
        const roleAdmin = Storage.getRoleAdmin()
        
        return (
            <div className="rrs">
                <SecureGateRoute />
                <div id="main-content">
                    <div className="page-body">
                        <BreadCrumb breadcrumb={[
                            { name: 'RRS Home', url: AppSettings.defaultUrl },
                            { name: 'User Manual', url: '' }
                        ]}></BreadCrumb>
                        <div className="sp-page-header-panel row">
                            <div className="col-md-5 sp-page-header">
                                <h1 className="sp-page-header1">User Manual</h1>
                            </div>
                        </div>
                        <div className="sp-page-result-container" style={{ marginTop: 18 }} id="user" >
                            <div className="sp-table-container">
                                <div className="row rrs-table-hdr-wrap">
                                    {/* <div className="col-md-2">
                                        <h2 className="rrs-table-hdr">ผู้ใช้งานระบบ</h2>
                                    </div> */}
                                </div>
                                { roleAdmin && appReadonly == false && (
                                    <div className="row sp-pagination-control-top">
                                        <div className="col-auto create-button" >
                                            <a href="#" className="sp-bt-addmore" onClick={() => this.setUserManualModal()} data-toggle="modal" data-target="#userManualModal">
                                                <i className="icon btn-plus" />
                                                <span>เพิ่ม</span>
                                            </a>
                                        </div>
                                    </div>
                                )}
                                <div className="row no-gutters sp-table-content">

                                    <Table aria-labelledby="tableTitle" className="sp-table table rrs-table">
                                        <TableHead>
                                            <TableRow className="sp-table-header">
                                            <TableCell className="th-table text-center" style={{ width: '20px', maxWidth: '20px' }}>เรียกดู</TableCell>
                                            <TableCell className="th-table text-center" style={{ width: '50px', maxWidth: '50px' }}>กลุ่มผู้ใช้</TableCell>
                                                <TableCell className="th-table text-center" style={{ width: '50px', maxWidth: '50px' }}>ชื่อเอกสาร</TableCell>
                                                <TableCell className="th-table text-center" style={{ width: '150px', maxWidth: '150px' }}>รายละเอียด</TableCell>
                                                {/* <TableCell className="th-table text-center" style={{ width: '20px', maxWidth: '20px' }}>Edit</TableCell> */}
                                                <TableCell className="th-table text-center" style={{ width: '20px', maxWidth: '20px', display: (roleAdmin && appReadonly == false) ? "" : "none" }}>ลบ</TableCell>
                                            </TableRow>
                                            {/* <TableRow className="sp-table-filter">
                                                <TableCell></TableCell>
                                                <TableCell><input type="text" name="filter_username" className="form-control" onChange={this.handleChangefilter} value={filter_username} /></TableCell>
                                                <TableCell><input type="text" name="filter_firstName" className="form-control" onChange={this.handleChangefilter} value={filter_firstName} /></TableCell>
                                            </TableRow> */}
                                        </TableHead>
                                        <TableBody>
                                            {Array.isArray(filteruserDataArr) && (this.stableSort(filteruserDataArr, this.getSorting(this.state.order_user, this.state.orderBy_user))
                                                .slice(this.state.page_user * this.state.rowsPerPage_user, this.state.page_user * this.state.rowsPerPage_user + this.state.rowsPerPage_user)
                                                .map((row, index) => {
                                                    return (
                                                        <TableRow
                                                            hover
                                                            tabIndex={-1}
                                                            key={index}
                                                        >
                                                            <TableCell className="action-icon">
                                                                <a href={row.file_url} target="_blank"><i className="icon icon-preview-eye-blue" /></a>
                                                            </TableCell>
                                                            <TableCell className="text-center"><label className="label-full text-grid">{row.user_group}</label></TableCell>
                                                            <TableCell className="text-center"><label className="label-full text-grid">{row.title}</label></TableCell>
                                                            <TableCell className="text-center"><label className="label-full text-grid">{row.detail}</label></TableCell>
                                                            {/* <TableCell className="action-icon">
                                                                <a href="#" onClick={() => this.setUserManualModal(1)} data-toggle="modal" data-target="#userManualModal">
                                                                    <i className="icon bt-edit" />
                                                                </a>
                                                            </TableCell> */}
                                                            <TableCell className="action-icon" style={{ display: (roleAdmin && appReadonly == false) ? "" : "none" }}>
                                                                <button className="btn" onClick={() => { this.delUser(row.id,row.file_path) }}>
                                                                    <i className="icon btn-minus" />
                                                                </button>
                                                            </TableCell>
                                                        </TableRow>
                                                    );

                                                }))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        className="pager"
                                        rowsPerPageOptions={[10, 25, 50, 100]}
                                        component="div"
                                        count={filteruserDataArr ? filteruserDataArr.length : 0}
                                        rowsPerPage={this.state.rowsPerPage_user}
                                        page={this.state.page_user}
                                        backIconButtonProps={{
                                            "aria-label": "previous page"
                                        }}
                                        nextIconButtonProps={{
                                            "aria-label": "next page"
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <UserManualModal onUploadComplete={() => this.onUploadComplete()} getUserManualData={() => this.loadDataManualUserAll()}/>
                <SearchEmployeeModal />
                {/* backtotop button */}
                <div className="backtotop-panel">
                    <span className="bt-backtotop btn">
                        <i className="icon btn-order-top" onClick={() => window.scroll({ top: 0, behavior: 'smooth' })} />
                    </span>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { AppRedux, UserManualRedux } = state
    return {
        userManualData: UserManualRedux.userManualData,
        tagErrors: AppRedux.tagErrors,
        errorMsg: UserManualRedux.errorMsg,
    }
}

const mapDispatchToProps = dispatch => {
    return {

        getUserManualData: () => dispatch(getUserManualDataAction()),
        updateUserModal: (data) => dispatch(updateUserManualModalAction(data)),
        deleteUser: (id,file_path) => dispatch(deleteUserManualAction(id,file_path)),
        clearErrorMsg: () => dispatch(clearErrorMsgAction())

    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ManualScreen);